module.exports = __webpack_public_path__ + "img/Fujian-speed.99ee28fa.png";